export default {
    SaveContract: '/index.php/cqh/Contract/SaveContract',//保存项目合同
    SaveContractPay: '/index.php/cqh/Contract/SaveContractPay',//保存付款进度
    GetContract: '/index.php/cqh/Contract/GetContract',//获取项目合同和资金进度
    PayStatusChange: '/index.php/cqh/Contract/PayStatusChange',//付款状态变更
    GetLog: '/index.php/cqh/Contract/GetLog',//获取操作记录
    GetContractPayShenheLog: '/index.php/cqh/Contract/GetContractPayShenheLog',//获取审批详情
    SaveConstruction: '/index.php/cqh/Contract/SaveConstruction',//保存建设单位
    SaveConstructionUser: '/index.php/cqh/Contract/SaveConstructionUser',//保存建设单位负责人
    GetConstruction: '/index.php/cqh/Contract/GetConstruction',//获取建设单位以及人员
    WaitShenheProject: '/index.php/cqh/Contract/WaitShenheProject',//待审批项目
    MyWait: '/index.php/cqh/Contract/MyWait',//我的待办
    GetTopNum: '/index.php/cqh/Contract/GetTopNum',//获取头部数字
    GetMyConstruction: '/index.php/cqh/Contract/GetMyConstruction',//获取当前登录人建设单位
    WaitPayProject: '/index.php/cqh/Contract/WaitPayProject',//待拨款项目
};